import { format } from "rut.js";
import { columns } from "../../../dtos/columns";
import { TotalCartera } from "../models/totalCartera";
//import AccionesBandejaMutuo from "../components/accionesBandejaMutuo";
import { numericFormatter } from "react-number-format";
import { FiltroCartera } from "../models/filtroCartera";
import { TablaBasicFilter } from "../../../utils/tableBasicFilter";
import AccionesCartera from "../components/accionesCartera";
import Conversiones from "../../../utils/conversiones";

interface IProps {
    control: any;
    filtros: FiltroCartera | TablaBasicFilter;
}

export function useColumns({ control, filtros }: IProps) {

    const COLUMNS: columns<TotalCartera>[] = [
        {
            name: 'Acciones',
            selector: (row: TotalCartera) => '',
            cell: (row: TotalCartera) => //row.estado != "Por Ingresar" ?
                <AccionesCartera
                    cartera={row}
                    control={control}
                    filtros={filtros}
                />/* : ""*/,
            allowOverflow: true,
            button: true,
            export: false,
        },
        {
            name: 'OMD',
            selector: (row: TotalCartera) => row.omd,
            sortable: true,
            sortField: 'omd',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'N° Solicitud',
            selector: (row: TotalCartera) => row.numeroSolicitud,
            sortable: true,
            sortField: 'numeroSolicitud',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'N° Operación',
            selector: (row: TotalCartera) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Nombre o razón social',
            selector: (row: TotalCartera) => row.nombre,
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: 'RUT',
            selector: (row: TotalCartera) => format(row.rut),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: 'Tipo mutuo',
            selector: (row: TotalCartera) => row.tipoMutuo,
            sortable: true,
            sortField: 'tipoMutuo',
            wrap: true,
            export: true,
            alling: 'left',
        },
        {
            name: 'Plazo',
            selector: (row: TotalCartera) => row.plazo,
            sortable: true,
            sortField: 'plazo',
            wrap: false,
            export: true,
            alling: 'right'
        },
        {
            name: 'Monto',
            selector: (row: TotalCartera) => row.monto,
            cell: (row: TotalCartera) => numericFormatter(row.monto.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'monto',
            wrap: false,
            export: true,
            alling: 'right'

        },
        /*{
            name: 'Saldo insoluto',
            selector: (row: TotalCartera) => row.saldoInsoluto,
            cell: (row: TotalCartera) => numericFormatter(row.saldoInsoluto.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": ",", "prefix": "UF " }),
            sortable: true,
            sortField: 'saldoInsoluto',
            wrap: false,
            export: true,
            alling: 'right'

        },*/
        {
            name: 'Estado',
            selector: (row: TotalCartera) => Array.isArray(row.estados) ? row.estados.join(', ') : row.estados,
            cell: (row: TotalCartera) => row.estados.map((x) => {return <>{x}<br/></>}),
            sortable: true,
            sortField: 'estados',
            wrap: false,
            export: true,
            alling: 'left'
        },
        {
            name: "Fecha último estado",
            selector: (row: TotalCartera) => Conversiones.formatDate(new Date(row.fechaEstado), "/"),
            cell: (row: TotalCartera) => Conversiones.formatDate(new Date(row.fechaEstado), "/"),
            sortable: true,
            sortField: 'estados',
            wrap: false,
            export: true,
            alling: 'left'
        },
        {
            name: 'Emisor',
            selector: (row: TotalCartera) => row.emisor,
            sortable: true,
            sortField: 'emisor',
            wrap: true,
            export: true,
            alling: 'left'
        },
        {
            name: 'Postergación dividendo',
            selector: (row: TotalCartera) => row.postergacion,
            cell: (row: TotalCartera) => row.postergacion === 'Y' ? <b style={{color: '#f44336'}}>Sí</b> : 'No',
            sortable: true,
            sortField: 'postergacion',
            wrap: true,
            export: true,
            alling: 'left'
        },
        {
            name: 'Código mutuo',
            selector: (row: TotalCartera) => row.codigoMutuo,
            sortable: true,
            sortField: 'codigoMutuo',
            wrap: true,
            export: true,
            alling: 'left'
        },

    ]

    return { COLUMNS };
}